import { render, staticRenderFns } from "./UnitLosListItemNew.vue?vue&type=template&id=b0673350&scoped=true&"
import script from "./UnitLosListItemNew.vue?vue&type=script&lang=js&"
export * from "./UnitLosListItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0673350",
  null
  
)

export default component.exports